export default __webpack_public_path__ + "static/media/awar13.f49cab6d.jpg";